import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: [remCalc(40), remCalc(40), remCalc(40), remCalc(38)],
            alignSelf: 'stretch',
            paddingY: [remCalc(40), remCalc(40), remCalc(40), remCalc(80)],
        },
        breadcrumb: {
            padding: remCalc(0),
            minHeight: 'unset',
        },
        titleContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(4),
            width: '100%',
        },
        titleSection: {
            display: 'flex',
            padding: {base: `${remCalc(22)} 0 ${remCalc(16)}`, lg: `${remCalc(24)} 0`},
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
            borderBottom: 'small',
            borderColor: 'border.light',
            width: '100%',
        },
        title: {
            textStyle: {
                base: 'head-medium',
                lg: 'head-xlarge',
            },
            fontWeight: 'medium',
            color: 'text.default',
        },
        mainContainer: {
            display: 'flex',
            width: '100%',
            alignItems: ['flex-start'],
            flexDirection: ['column', 'column', 'column', 'row'],
            gap: [remCalc(40), remCalc(40), remCalc(40), remCalc(144)],
            justifyContent: ['unset', 'unset', 'unset', 'space-between'],
            paddingTop: [0, 0, 0, remCalc(4)],
        },
        phoneContainer: {
            display: 'flex',
            maxWidth: remCalc(568),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            width: '100%',
        },
        messageContainer: {
            display: 'flex',
            maxWidth: remCalc(687),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            width: '100%',
        },
        messageInnerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        messageIconTitle: {
            display: 'flex',
            alignItems: 'center',
            gap: {base: remCalc(24), lg: remCalc(22)},
            flexDirection: {base: 'column', lg: 'row'},
        },
        instructionsText: {
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: 'normal',
            alignSelf: 'stretch',
        },
        messageTitle: {
            textStyle: 'head-small',
            color: 'text.default',
            fontWeight: 'medium',
        },
        emailIcon: {
            boxSize: remCalc(32),
        },
        numbersContainer: {
            display: 'flex',
            padding: [0, 0, 0, remCalc(12)],
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
        },
        numberLabel: {
            display: 'flex',
            padding: `${remCalc(22)} 0`,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
            borderTop: 'small',
            borderColor: 'border.light',
            width: '100%',
        },
        numberText: {
            textStyle: 'body-small',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        numberTextVariant: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        numberLabelVariant: {
            display: 'flex',
            padding: `${remCalc(22)} 0`,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(14),
            alignSelf: 'stretch',
            borderTop: 'small',
            borderColor: 'border.light',
            width: '100%',
        },
        formsContainer: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            width: '100%',
            gap: remCalc(32),
        },
        formsPairContainer: {
            display: 'flex',
            width: '100%',
            alignItems: 'flex-start',
            gap: remCalc(24),
        },
        uploadFileContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            alignSelf: 'stretch',
            width: '100%',
        },
        fileNameContainer: {
            display: 'flex',
            width: '100%',
            minWidth: remCalc(140),
            minHeight: remCalc(40),
            padding: `${remCalc(8)} ${remCalc(16)}`,
            alignItems: 'center',
            alignSelf: 'stretch',
            borderRadius: remCalc(4),
            border: '1px solid',
            borderColor: 'border.secondary',
            background: 'background.default',
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            pointer: 'cursor',
        },
        fileButton: {
            minWidth: remCalc(140),
        },
        fileNameLabel: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        button: {
            display: 'flex',
            height: remCalc(40),
            minWidth: remCalc(140),
            width: remCalc(332),
            maxHeight: remCalc(40),
            padding: `${remCalc(18)} ${remCalc(24)}`,
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'stretch',

            marginTop: remCalc(4),
        },
        confirmationButtonText: {
            textStyle: 'body-medium',
            fontWeight: 'bold',
            color: 'button.text.secondary-default',
        },
        confirmIcon: {
            display: 'flex',
            boxSize: remCalc(24),
            alignSelf: 'center',
            flexShrink: 0,
            justifyContent: 'center',
            alignItems: 'center',
        },
        confirmationContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: ['center', 'center', 'center', 'flex-start'],
            justifyContent: ['center', 'center', 'center', 'unset'],
            gap: [remCalc(32), remCalc(32), remCalc(32), remCalc(40)],
            alignSelf: 'stretch',
            width: '100%',
            maxWidth: remCalc(688),
            padding: [`0 ${remCalc(16)}`, `0 ${remCalc(16)}`, `0 ${remCalc(16)}`, '0'],
        },
        confirmationInnerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: ['center', 'center', 'center', 'flex-start'],
            justifyContent: ['center', 'center', 'center', 'unset'],
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        confirmationText: {
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: 'normal',
            alignSelf: ['center', 'center', 'center', 'stretch'],
            textAlign: {base: 'center', lg: 'left'},
        },
        personalData: {
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.default',
            marginY: remCalc(4),
            width: '100%',
        },
        bottomContainer: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
        },
        errorMessage: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.danger',
            width: '100%',
            paddingTop: [0, 0, 0, remCalc(42)],
        },
        dummyBox: {
            width: '100%',
            display: ['none', 'none', 'none', 'block'],
        },
    },
}
